import { DarkModeButton } from 'atoms/DarkModeButton';
import LanguageSwitcher from 'atoms/LanguageSwitcher';
import { cvtClassName } from 'commons/utils';
interface TransparentFooterProps {
  textColor?: string;
}

export const TransparentFooter = ({ textColor }: TransparentFooterProps) => {
  const footerBaseClass = [
    'fixed',
    'bottom-0',
    'left-0',
    'w-full',
    'py-5',
    'px-3',
    'text-clamp_s',
    'bg-transparent',
  ];

  const footerClass = [
    'flex',
    'flex-col',
    'items-center',
    'justify-center',
    'border-t-2',
    'border-solid',
    'border-[--c-line]',
    'h-16',
    'bg-transparent',
  ];

  return (
    <footer className={cvtClassName(footerBaseClass)}>
      <div className={cvtClassName(footerClass)} style={{ color: textColor }}>
        <div className="flex flex-col items-center justify-center w-full">
          <div className="flex items-center justify-center pt-5 gap-4">
            <DarkModeButton sx={{ mx: 1 }}></DarkModeButton>
          </div>
          <p className="text-center">
            © Sony Music Entertainment (Japan) Inc. All rights reserved.
          </p>
          <a
            className="ot-sdk-show-settings text-sm underline cursor-pointer"
            href="#ot-sdk-btn"
            aria-label="Cookie Settings"
          >
            Cookies Settings
          </a>
        </div>
      </div>
    </footer>
  );
};
